import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('processing'); // processing, success, error
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        console.log('AuthCallback - Processing hash:', hash);
        
        const sessionIdMatch = hash.match(/session_id=([^&#]+)/);
        const sessionId = sessionIdMatch ? sessionIdMatch[1] : null;
        
        console.log('AuthCallback - Extracted session_id:', sessionId);

        if (!sessionId) {
          console.error('No session_id found in URL');
          setStatus('error');
          setTimeout(() => {
            window.location.href = '/#contact';
          }, 1000);
          return;
        }

        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error('Failed to authenticate');
        }

        const userData = await response.json();
        console.log('AuthCallback - User data received:', userData);
        
        updateUser(userData);
        localStorage.setItem('auth_user', JSON.stringify(userData));
        
        setStatus('success');
        setRedirecting(true);
        
      } catch (error) {
        console.error('Auth callback error:', error);
        setStatus('error');
        setTimeout(() => {
          window.location.href = '/#contact';
        }, 1000);
      }
    };

    processAuth();
  }, [updateUser]);

  // Handle redirect after success - render the home page inline
  if (redirecting) {
    // Set flag BEFORE reload so Home component can read it
    sessionStorage.setItem('scrollToContact', 'true');
    // Clear URL and redirect smoothly
    window.history.replaceState(null, '', '/#contact');
    // Small delay then reload to show logged-in state
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#a8cef1] to-[#7eb3e3]">
      <div className="text-center text-white">
        {status === 'processing' && (
          <>
            <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-xl">Signing you in...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-xl">Success!</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <p className="text-xl">Something went wrong. Redirecting...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
